<!--护士-->
<template>
	<div style="position:relative">
		<div class="alarm-item-con" style=" min-width:1200px;" @click="lightBoxClick">
			<div v-if="isShowSearchCom">
				<SearchCop @searchRoom="searchRoom"></SearchCop>
			</div>
			<div v-else class="seach-text">
				关于“{{ seachText }}”共搜索到
				<span class="seach-text-height">{{ roomList ? roomList.length : '0' }}</span> 条结果
				<span class="seach-text-height seach-text-hover" @click="backList">返回</span>
			</div>
			<div class="contant">
				<div v-for="(item, index) in (roomList || [])" :key="index" @click="toDetailPage(item)">
					<BedItem
						:roomData="item"
						:showAlarmActions="role == 3 && !!item.hasAlarm"
						@cancel-alarm="showCancelAlarmDialog(item)"
						@view-detail="toDetailPage(item)"
					></BedItem>
				</div>
			</div>
			<div v-if="isShowDialog && this.role != 2">
				<Dialog ref="dialog" @closeDialog="closeDialog" :dialogData="dialogData"></Dialog>
			</div>
			<QLConfirmDialog
				:visible.sync="isCancelAlarmDialogVisible"
				:description="cancelAlarmDescription"
				:icon="warningIcon"
				:buttons="cancelAlarmDialogButtons"
				@button-click="handleCancelAlarmDialogButton"
			></QLConfirmDialog>
		</div>
		<!-- <div class="aaaa" v-if="AlarmTone && role == '3'">
			<p>系统将会开启报警音</p>
			<a-button type="primary" @click="aaaa">确定</a-button>
		</div> -->
		<div class="real-time-bg">
			<div class="bg-left"></div>
			<div class="bg-right"></div>
		</div>
	</div>
</template>

<script>
//引用文件
import mp3 from '../../assets/video/sound_Alarm.mp3';
import BedItem from './compoent/bedItem.vue';
import Dialog from './compoent/dialog.vue';
import SearchCop from './compoent/searchCop.vue';
import QLConfirmDialog from '../common/QLConfirmDialog.vue';
import warningIcon from '../../assets/icon_alert_warning.png';
import { createGlobalStompScope } from '@/utils/stomp';
import Global from '../../utils/global';

export default {
	components: {
		BedItem,
		SearchCop,
		Dialog,
		QLConfirmDialog,
	},
	data() {
		return {
			role: 2,
			tenantId: null,
			isShowSearchCom: true,
			seachText: '',
			isShowDialog: false,
			isCancelAlarmDialogVisible: false,
			isCancelAlarmRequesting: false,
			cancelAlarmRoom: null,
			warningIcon,
			cancelAlarmDialogButtons: [
				{
					key: 'back',
					text: '返回',
					style: {
						background: '#fff',
						border: '1px solid #d9d9d9',
						color: 'rgba(0, 0, 0, 0.65)',
					},
				},
				{
					key: 'cancel-alarm',
					text: '取消报警',
					style: {
						background: '#fff',
						border: '1px solid #d9d9d9',
						color: 'rgba(0, 0, 0, 0.65)',
					},
				},
			],
			roomList: [],
			dialogData: [],
			stompClientStatus: null,
			stompClientStatusAlarm: null,
			AlarmTone: true,
			lightBox: false,
			audio: null,
			alarmFlag: false,
			alalrmInterval: null,
			alalrmTimeOut: null,
			speakMsg: null,
			bedIdArr: [],

			nowPageTime: 0,       //当前页面时间，用于计时
			action: 1,
			isFirstIn: true,
			searchFloor: '',
			searchLayer: '',
			searchText: '',
			isRequest: false,
			manualCancelRefreshTimer: null,
		};
	},
	created() {
		this.tenantId = this.$getCookie('userInfo').user.tenantId;
		this.role = this.$getCookie('userInfo').user.roleId;
		console.log(this.dialogData);
		this.dialogData = [];

	},
	computed: {
		cancelAlarmDescription() {
			if (!this.cancelAlarmRoom) {
				return '';
			}
			const roomName = [this.cancelAlarmRoom.buAndFlName, this.cancelAlarmRoom.roomName]
				.filter(Boolean)
				.join('-');
			return `即将取消 ${roomName} 的报警，请一定确保用户目前是安全的再操作。取消后，在有新报警前，不会再提示，确定取消？`;
		},
	},
	mounted() {
		Global.$on('manualCancelEvent', this.handleManualCancelEvent);
		this.searchRoom('', '', '', false, false);
		this.searchAlarm(true);
		this.getSocketStatus();
		// this.getSocketStatusAlarm();
		this.listenPage();
		// let DomData = document.querySelectorAll('.ant-message-notice-content');
		// DomData[0].style.opacity = '0';
		// console.log(DomData);
		if (this.role == '3') {
			let audio = document.getElementById('music');
			audio.volume = 0;
			// audio.play();
		}
		if (sessionStorage.getItem('aval')) {
			this.AlarmTone = false;
			if (this.role == '3') {
				setTimeout(() => {
					this.aaaa();
				}, 1000);
			}
		} else {
			sessionStorage.setItem('aval', 2);
			this.AlarmTone = true;
		}
		// this.timeRefresh();     //针对德龙机构计时刷新页面
	},
	methods: {
		handleManualCancelEvent(tenantId) {
			if (String(tenantId) !== String(this.tenantId)) {
				return;
			}
			this.refreshShowListAfterManualCancel();
		},
		refreshShowListAfterManualCancel() {
			if (this.manualCancelRefreshTimer) {
				clearTimeout(this.manualCancelRefreshTimer);
			}
			if (this.isRequest) {
				this.manualCancelRefreshTimer = setTimeout(() => {
					this.refreshShowListAfterManualCancel();
				}, 100);
				return;
			}
			this.manualCancelRefreshTimer = null;
			this.searchRoom('', '', '', false, true);
		},
		showCancelAlarmDialog(room) {
			this.cancelAlarmRoom = room;
			this.isCancelAlarmDialogVisible = true;
		},
		handleCancelAlarmDialogButton(button) {
			if (button.key === 'back') {
				this.isCancelAlarmDialogVisible = false;
				return;
			}
			if (button.key === 'cancel-alarm') {
				this.cancelAlarm();
			}
		},
		cancelAlarm() {
			if (this.isCancelAlarmRequesting || !this.cancelAlarmRoom) {
				return;
			}
			const bedListMap = this.cancelAlarmRoom.bedListMap || {};
			const mceList = Object.keys(bedListMap).reduce((result, key) => {
				const bedList = bedListMap[key] || [];
				bedList.forEach((item) => {
					if (item && item.hasAlarm === true) {
						result.push({
							bedId: item.bedId,
							eventId: item.eventId,
							snCode: item.sn || '',
							tenantId: item.tenantId || ''
						});
					}
				});
				return result;
			}, []);

			if (mceList.length === 0) {
				this.$message.error('该房间暂无可取消的报警');
				return;
			}

			this.isCancelAlarmRequesting = true;
			this.$post(
				'/api/event/manualCancelEvent',
				{ mceList },
				(res) => {
					this.isCancelAlarmRequesting = false;
					if (res.code == 0) {
						this.isCancelAlarmDialogVisible = false;
						this.cancelAlarmRoom = null;
						this.searchRoom('', '', '', false, true);
						this.searchAlarm();
						return;
					}
					this.$message.error(res.msg || '取消报警失败');
				},
				(err) => {
					this.isCancelAlarmRequesting = false;
					this.$message.error((err && err.msg) || '取消报警失败');
				}
			);
		},
		showAlarmDialog() {
			this.isCancelAlarmDialogVisible = false;
			this.isShowDialog = true;
		},
		// 针对德龙机构计时刷新页面
		// timeRefresh() {
		// 	let tenantId = this.$getCookie('userInfo').user.tenantId;
		// 	console.log('当前tenantId为' + tenantId)
		// 	// if(tenantId == 59 || tenantId == 119){
		// 	let timeRefName = setInterval((res) => {
		// 		this.nowPageTime += 1
		// 		console.log('正在计时...' + this.nowPageTime)
		// 		let nowPageRouter = this.$route.path;
		// 		// if(this.nowPageTime == 10){       //若计时半小时了
		// 		if (this.nowPageTime == 1800) {       //若计时半小时了
		// 			if (nowPageRouter == '/protect/home') {
		// 				this.$router.go(0);
		// 			}
		// 		}
		// 	}, 1000)
		// 	// 通过 $once 来监听定时器，在 beforeDestroy 钩子可以被清除。
		// 	this.$once('hook:beforeDestroy', () => {
		// 		if (timeRefName) {
		// 			clearInterval(timeRefName);
		// 		}
		// 		timeRefName = null;
		// 	})
		// 	// }
		// },
		dddd(str) {
			if (this.role != '3') {
				return
			}
			let newstr = str.split('').join(' ');
			this.speakMsg = new SpeechSynthesisUtterance(newstr);
			this.speakMsg.rate = 1; // 语速
			this.speakMsg.lang = 'zh';
			this.speakMsg.pitch = 0.5; // 音量
			window.speechSynthesis.speak(this.speakMsg);
			// 兼容语音播报
			// var url =
			//   'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=0&tex=' +
			//   encodeURI(newstr); // baidu文字转语音
			// var audio = new Audio(url);
			// audio.src = url;
			// audio.play();
		},
		//停止音频
		stopAudio(data) {
			// let audio = document.getElementById('music');
			// audio.volume = 0;
			// audio.pause();
			// window.speechSynthesis.cancel()
			// for (let index = 0; index < 1000000; index++) {
			//	 clearInterval(index);
			// }
			if (data === 1) {
				this.GoHandle();
			}
			setTimeout(() => {
				this.$message.destroy();
			}, 1000);
			// this.timeRefresh();     //针对德龙机构计时刷新页面
		},
		GoHandle(e) {
			this.speakMsg = null;
			this.speakMsg ? (this.speakMsg.pitch = 0) : null; // 音量
			if (this.alalrmInterval) {
				clearInterval(this.alalrmInterval);
			}
			if (this.alalrmTimeOut) {
				clearTimeout(this.alalrmTimeOut);
			}
			this.alalrmInterval = null;
			this.alalrmTimeOut = null;
			let params = {}
			let alarmEventList = [];
			this.dialogData.forEach((item) => {
				alarmEventList.push(
					{
						bedId: item.bedId,
						radarType: item.radarType
					}
				);
			});
			params.alarmEventList = alarmEventList;
			params.action = this.action;
			this.$post(
				'/api/event/batchEventProc',
				params,
				(res) => {
					console.log('===dialogData===', this.dialogData)
					let tempData = JSON.parse(JSON.stringify(this.dialogData)) || [];
					for (let i = 0; i < tempData.length; i++) {
						tempData[i].status = 6;
					}
					this.dialogData = tempData;
					if (this.alalrmInterval) {
						clearInterval(this.alalrmInterval);
						this.alalrmInterval = null;
					}
					let audio = document.getElementById('music');
					audio.volume = 0;
					audio.pause();
					window.speechSynthesis.cancel()
				},
				(err) => {
					//console.log(err);
				}
			);
			// this.timeRefresh();     //针对德龙机构计时刷新页面
		},
		lightBoxClick() {
			this.action = 1;
			this.stopAudio(1);
		},
		aaaa() {
			if (this.role != '3') {
				return
			}
			this.stopAudio();
			this.AlarmTone = false;
			if (this.alalrmInterval) {
				clearInterval(this.alalrmInterval);
				this.alalrmInterval = null;
			}
			let audio = document.getElementById('music');
			audio.volume = 0;
			audio.pause();
			window.speechSynthesis.pause();
			window.speechSynthesis.resume();
			window.speechSynthesis.cancel()
			if (this.role == '3') {
				let str = this.getAlarmStr();
				if (str.length > 0) {
					let times = Math.ceil(str.length / 3) * 1000 + 3000;
					// console.log('===str===', str, str.length, times)
					this.alalrm(str);
					this.alalrmInterval = setInterval(() => {
						this.aaaa();
					}, times);
				} else {
					this.GoHandle();
				}
			}
		},
		getAlarmStr() {
			let str = '';
			console.log(this.dialogData, 'this.dialogDatathis.dialogData');
			if (this.dialogData && this.dialogData.length > 0) {
				this.dialogData.forEach((item) => {
					if (item.status === 5) {
						if (item.statusName == '需要帮助') {
							str += item.roomName + item.bedName + item.statusName;
						} else {
							str += item.roomName;
						}
					}
				});
			}
			return str;
		},
		alalrm(str) {
			let audio = document.getElementById('music');
			audio.play();
			audio.volume = 1;
			this.alalrmTimeOut = setTimeout(() => {
				this.dddd(str);
			}, 2200);
		},
		listenPage() {
			window.onbeforeunload = function (e) {
				sessionStorage.removeItem('aval');
			};
		},
		searchAlarm(isAlarm = false) {
			if (this.role == 2) {
				return;
			}
			this.$get(
				'/api/v3/bed/getBedAlarmList',			//报警列表
				{},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							let isUpdateDialogData = false
							if (res.data.length != this.dialogData.length) {
								isUpdateDialogData = true
							} else {
								for (let i = 0; i < this.dialogData.length; i++) {
									let tempItem1 = this.dialogData[i];
									let tempItem2 = res.data[i];
									if (tempItem1.bedId != tempItem2.bedId || tempItem1.status != tempItem2.status || tempItem1.subStatus != tempItem2.subStatus || tempItem1.radarType != tempItem2.radarType || tempItem1.hasAlarm != tempItem2.hasAlarm || tempItem1.roomId != tempItem2.roomId) {
										isUpdateDialogData = true
									}
								}
							}
							if (isUpdateDialogData) {
								this.dialogData = [];
								this.dialogData = res.data;
							}
							this.tenantId = this.$getCookie('userInfo').user.tenantId;
							this.role = this.$getCookie('userInfo').user.roleId;
							if (this.role == '3' && isAlarm) {			//护工
								this.aaaa();
							}
							if (res.data.length === 0) {
								this.isShowDialog = false;
								this.stopAudio();
							} else {
								if (isUpdateDialogData) {
									this.dialogData = [];
									this.dialogData = res.data;
								}
								if (this.isFirstIn) {
									this.showAlarmDialog();
									this.isFirstIn = false;
								} else {
									res.data.forEach((item) => {
										if (item.status == 5) {
											this.showAlarmDialog();
										}
									});
								}
							}
							if (isUpdateDialogData) {
								setTimeout(() => {
									this.$refs.dialog
										? this.$refs.dialog.changeArray(this.dialogData, 3)
										: null;
								}, 1000);
							}
						}
					} else {
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		changeDomHeight() {
			let domroomList = document.querySelectorAll('.equipment-con');
			let listHight = [];
			let domHeight = null;
			for (let i = 0; i < domroomList.length; i++) {
				listHight.push(domroomList[i].clientHeight);
			}
			console.log(listHight);
			domHeight = Math.max(...listHight);
			for (let i = 0; i < domroomList.length; i++) {
				domroomList[i].style.height = domHeight + 'px';
			}
			let domroomList2 = document.querySelectorAll('.title-room');
			let listHight2 = [];
			let domHeight2 = null;
			for (let i = 0; i < domroomList2.length; i++) {
				listHight2.push(domroomList2[i].clientHeight);
			}
			console.log(listHight2);
			domHeight2 = Math.max(...listHight2);
			for (let i = 0; i < domroomList2.length; i++) {
				domroomList2[i].style.height = domHeight2 + 'px';
			}
		},
		searchRoom(floor = '', layer = '', text = '', isClick = false, isKeepSelect = false) {
			if (this.isRequest) {
				return
			}
			this.isRequest = true;
			if (isKeepSelect) {
				floor = this.searchFloor;
				layer = this.searchLayer;
				text = this.seachText;
			} else {
				this.searchFloor = floor;
				this.searchLayer = layer;
				this.seachText = text;
			}
			console.log(floor, layer, text);
			let params = {
				buildingId: floor,
				floorId: layer,
				search: text,
			};
			this.$get(
				'/api/v3/bed/showList',
				params,
				(res) => {
					this.isRequest = false;
					if (res.code == 0) {
						if (res.data) {
							// 旧版本
							// this.roomList = res.data;
							// if (res.data.length > 0) {
							// 	res.data.forEach((item) => {
							// 		if (item && item.bedList) {
							// 			item.bedList.forEach((jtem) => {
							// 				this.bedIdArr.push(jtem.bedId);
							// 			});
							// 		}
							// 	});
							// }

							// 新版本 处理数据
							if (res.data && res.data.length > 0) {
								for (let i = 0; i < res.data.length; i++) {
									res.data[i].bedList = [];
									if (res.data[i] && res.data[i].bedListMap) {
										let object = res.data[i].bedListMap;
										for (const key in object) {
											if (Object.hasOwnProperty.call(object, key)) {
												let elements = object[key] || [];
												let addItem = {};
												for (let k = 0; k < elements.length; k++) {
													let elementItem = elements[k];
													if (elementItem.radarType != 3) {
														addItem = elementItem;
													} else {
														addItem.sosSubStatus = elementItem.subStatus;
														addItem.sosStatusName = elementItem.statusName;
														addItem.sosHasAlarm = elementItem.hasAlarm;
														addItem.bedName = elementItem.bedName;
														addItem.bedId = elementItem.bedId;
													}
												}
												res.data[i].bedList.push(addItem);
											}
                                        }
									}
								}
							}
							this.roomList = res.data;
							if (res.data.length > 0) {
								res.data.forEach((item) => {
									if (item && item.bedList) {
										item.bedList.forEach((jtem) => {
											this.bedIdArr.push(jtem.bedId);
										});
									}
								});
							}

							if (isClick) {
								this.isShowSearchCom = false;
							} else {
								this.isShowSearchCom = true;
							}

							setTimeout(() => {
								this.changeDomHeight();
							}, 100);
						} else {
						}
					} else {
					}
				},
				(err) => {
					this.isRequest = false;
					//console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		backList() {
			this.searchRoom('', '', '', false, false);
		},
		closeDialog() {
			this.isShowDialog = false;
			this.action = 2;
			this.stopAudio(1);
		},
		toDetailPage(data) {
			console.log(data);
			if (this.role == '3') {
				this.$router.push({
					path: '/protect/realTimeMonitoringtwo/?roomId=' + data.roomId,
				});
			} else if (this.role == '2') {
				this.$router.push({
					path: '/dean/realTimeMonitoringtwo/?roomId=' + data.roomId,
				});
			}
		},
		getSocketStatus() {
			let id = this.tenantId;
			if (this.stompClientStatus) {
				this.stompClientStatus.destroy();
				this.stompClientStatus = null;
			}
			this.stompClientStatus = createGlobalStompScope({
				vm: this,
				name: 'realtime-room-status',
			});
			// 连接
			console.log('Websocket - allRoomStatus - 开始重连 - 1');
			this.stompClientStatus.subscribe('/topic/allRoomStatus.' + id, ({ body: socketData }) => {
							if (socketData) {
								if (this.$route.path == '/dean/realTimeMonitoringtwo/') {
									return;
								}
								console.log('Websocket - allRoomStatus - 收到消息 - 2');
								this.searchRoom('', '', '', false, true);    //页面列表查询
								this.searchAlarm()    //报警列表查询
								// 设备报警
								if (socketData && socketData.bedList) {
									socketData.bedList.forEach((item) => {
										if (item.status === 5) {      //报警
											this.searchAlarm(true);
										}
									})
								}
								// 设备自动解除报警
								if (this.dialogData && socketData) {
									this.dialogData.forEach((item) => {
										if (socketData.bedList) {
											socketData.bedList.forEach((jtem) => {
												if (item.bedId === jtem.bedId) {
													if (jtem.status !== 5) {
														// this.searchAlarm(true);
													}
												}
											});
										}
									});
								}
							}
						});
			this.stompClientStatus.connect();
		},

		getSocketStatusAlarm() {
			let id = this.tenantId;
			if (this.stompClientStatusAlarm) {
				this.stompClientStatusAlarm.destroy();
				this.stompClientStatusAlarm = null;
			}
			this.stompClientStatusAlarm = createGlobalStompScope({
				vm: this,
				name: 'realtime-alarm-bed',
			});
			// 连接
			console.log('Websocket - alarmBed - 开始重连 - 1');
			this.stompClientStatusAlarm.subscribe('/topic/alarmBed.' + id, ({ body: socketData }) => {
							console.log('Websocket - alarmBed - 收到消息 - 2');
							if (socketData) {
								if (this.bedIdArr.includes(socketData.bedId)) {
									if (this.role != 2) {
										this.$router.push({
											path: '/protect/home',
										});
									}
								}
							}
						});
			this.stompClientStatusAlarm.connect();
		},
	},
	beforeDestroy() {
		Global.$off('manualCancelEvent', this.handleManualCancelEvent);
		if (this.manualCancelRefreshTimer) {
			clearTimeout(this.manualCancelRefreshTimer);
			this.manualCancelRefreshTimer = null;
		}
		if (this.stompClientStatus) {
			this.stompClientStatus.destroy();
			this.stompClientStatus = null;
		}
		if (this.stompClientStatusAlarm) {
			this.stompClientStatusAlarm.destroy();
			this.stompClientStatusAlarm = null;
		}
	},
};
</script>
<style lang="scss" scoped>
.real-time-bg {
	width: 100%;
	height: 100%;
	position: absolute;
	top: -15px;
	left: 0;
	z-index: 0;
	display: flex;
	justify-content: space-between;

	.bg-left {
		width: 500px;
		height: 570px;
		background: url('./../../assets/img/leftFlower@2x.png') no-repeat center;
		background-size: contain;
	}

	.bg-right {
		width: 500px;
		height: 570px;
		background: url('./../../assets/img/rightFlower@2x.png') no-repeat center;
		background-size: contain;
	}
}

.alarm-item-con {
	width: 80%;
	margin: 0 auto;
	position: relative;
	z-index: 1;

	.seach-text {
		margin: 35px 0 20px 40px;
	}

	.seach-text-height {
		color: #1890ff;
	}

	.seach-text-hover {
		cursor: pointer;
	}
}

.aaaa {
	width: 200px;
	line-height: 50px;
	text-align: center;
	background: #ffffff;
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 20000;
	// z-index: -1000;
	border-radius: 4px;
	box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);

	p {
		margin-bottom: 0;
	}
}

.contant {
	display: flex;
	margin-bottom: 16px;
	flex-wrap: wrap;
}
</style>
